const initialState = {
  invoiced_on: undefined,
  payer: undefined,
  due_by: undefined,
  amount: '',
  memo: '',
  ui: {
    is_submitting: false,
    show: false,
  }
}

export default function newInvoiceForm(state=initialState, action){
  switch(action.type){
    case "UPDATE_NEW_INVOICE_UI":
     return {
        ...state,
        ui: {
          ...state.ui,
          ...action.payload,
        }
     }
    case "UPDATE_NEW_INVOICE_FIELD":
      return {
        ...state,
        ...action.payload
      }
    case "BEGIN_SUBMIT_NEW_INVOICE":
      return {
        ...state,
        ui: {
          ...state.ui,
          is_submitting: true,
        }
      }
    case "SUCCESS_SUBMIT_NEW_INVOICE":
      return {
        ...initialState,
      }
    case "FAILED_NEW_INVOICE":
      return {
        ...state,
        errors: action.payload.errors
      }
    case "RESET_NEW_INVOICE_FORM":
      return initialState;
    default:
      return state
  }
}